import {Composition, registerRoot} from 'remotion';
import {VoidlineMaryCeleste} from './Composition';

const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition
        id="VoidlineMaryCeleste"
        component={VoidlineMaryCeleste}
        durationInFrames={20050}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{}}
      />
    </>
  );
};

registerRoot(RemotionRoot);
